import classnames from 'classnames/bind'

// Libs

// Components
// import DeliverOption from './component/OptionItem'
import SelectedItem from './component/SelectedItem'
import { useDeliveryMethod } from '@/components/pages/ShoppingCart/hooks/useDeliveryMethod'
// import { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { useRef } from 'react'
// Constants
// import { useState } from 'react'

// Styles
import styles from './style.module.scss'
import useMedia from '@/hooks/useMedia'
const cx = classnames.bind(styles)

interface DeliverProps {
  className?: string
  handleSearchKeyChange?: (value: string) => void
  merchantId: number
  options?: any
  deliverOption?: any
  shippingDays?: number
  labelClassName?: string
  logistics?: string[]
  productPrice?: number
}
interface DeliverData {
  name: string
  description: string
  logisticsType: string
  logisticsSubType: string
  logisticsAmount: number
  logisticsAmountDisplay: number
  freeShippingThreshold?: number
}

const Deliver = ({ className, merchantId, shippingDays, labelClassName, logistics, productPrice }: DeliverProps) => {
  // const [isOpen, setIsOpen] = useState(false)
  const selectRef = useRef<any>(null)
  const { isDesktop } = useMedia()
  const { deliveryMethodData } = useDeliveryMethod({ merchantId })
  const { t } = useTranslation('')

  const findMinMaxPrice = (array: DeliverData[] = []) => {
    const logisticsDisplays = array.map((item) => item.logisticsAmountDisplay).filter((value) => typeof value === 'number')
    // 運費為 0，或商品價格達到該物流的免運門檻，即視為免運
    const isItemFree = (item: DeliverData) =>
      item.logisticsAmount === 0 || (!!item.freeShippingThreshold && typeof productPrice === 'number' && productPrice >= item.freeShippingThreshold)
    const isFree = array.length > 0 && array.every(isItemFree)
    return { min: Math.min(...logisticsDisplays), max: Math.max(...logisticsDisplays), isFree }
  }
  // 商品 API 沒回 logistics 時不過濾，維持原本全部顯示
  const availableMethods = Array.isArray(logistics)
    ? deliveryMethodData?.filter((item: DeliverData) => logistics.includes(item.logisticsType))
    : deliveryMethodData
  const { max = 0, min = 0, isFree } = findMinMaxPrice(availableMethods)

  {
    /* TODO: 第二階段做 下拉式選單用的 */
  }

  // useEffect(() => {
  //   const handleOutsideClick = (event: MouseEvent) => {
  //     if (selectRef.current && !selectRef.current.contains(event.target)) {
  //       setIsOpen(false)
  //     }
  //   }
  //   document.addEventListener('click', handleOutsideClick)

  //   return () => {
  //     document.removeEventListener('click', handleOutsideClick)
  //   }
  // }, [])
  // const toggleSelect = () => {
  //   setIsOpen(!isOpen)
  // }
  // const handleOptionSelect = (event: ClickEve) => {
  //   //點擊邏輯
  //   console.log('Selected value:', event.target.value)
  //   setIsOpen(false)
  // }

  return (
    <>
      {!!availableMethods?.length && (
        <div className={cx('deliver', className)}>
          <div className={cx('deliver__wrapper')}>
            {isDesktop && <div className={cx('deliver__title', labelClassName)}>{t('Common_Deliver')}</div>}
            <div className={cx('deliver__select')} ref={selectRef} onClick={() => {}}>
              <div className={cx('deliver__select-selected')}>
                <SelectedItem shippingDays={shippingDays} isFree={isFree} minPrice={min} maxPrice={max} />
              </div>
              {/* TODO: 第二階段做 下拉式選單*/}
              {/* {isOpen && (
              <div className={cx('deliver__select-options')}>
                <DeliverOption />
                <DeliverOption isFree />
                <DeliverOption />
                <DeliverOption />
                <DeliverOption />
              </div>
            )} */}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
export default Deliver
